import { Component, DoCheck, Input } from '@angular/core';
import { IAnswer, IApplication } from 'src/app/models/application-form/application-form.model';

@Component({
    selector: 'appform-quick-guide',
    templateUrl: './quick-guide.component.html',
    styleUrls: ['./quick-guide.component.css'],
    standalone: false
})
export class QuickGuideComponent implements DoCheck {
  private static QUESTION_SET_CODE = 'progressive_commercial_contact';
  private static QUESTION_CODE_FIRST_NAME = 'progressive_commercial_first_name';
  private static QUESTION_CODE_LAST_NAME = 'progressive_commercial_last_name';
  private static QUESTION_CODE_EMAIL = 'progressive_commercial_email';
  private static QUESTION_CODE_PHONE = 'progressive_commercial_phone';

  @Input() formData: IApplication;

  public answers: IAnswer[];
  public firstName: string;
  public lastName: string;
  public emailAddress: string;
  public phoneNumber: string;

  ngDoCheck(): void {
    if (this.formData?.questionSets.list.length > 0) {
      const questionSet = this.formData?.questionSets.list.filter(
        (queSet) => queSet.question_set.code === QuickGuideComponent.QUESTION_SET_CODE
      );
      if (questionSet?.length > 0) {
        this.answers = questionSet[0].answers;
        if (this.answers.length > 0) {
          this.firstName =
            this.answers.filter((ans) => ans.question.code === QuickGuideComponent.QUESTION_CODE_FIRST_NAME)[0].value ?? 'Empty';
          this.lastName =
            this.answers.filter((ans) => ans.question.code === QuickGuideComponent.QUESTION_CODE_LAST_NAME)[0].value ?? 'Empty';
          this.emailAddress =
            this.answers.filter((ans) => ans.question.code === QuickGuideComponent.QUESTION_CODE_EMAIL)[0].value ?? 'Empty';
          this.phoneNumber =
            this.answers.filter((ans) => ans.question.code === QuickGuideComponent.QUESTION_CODE_PHONE)[0].value ?? 'Empty';
        } else {
          this.firstName = 'Empty';
          this.lastName = 'Empty';
          this.emailAddress = 'Empty';
          this.phoneNumber = 'Empty';
        }
      }
    }
  }
}
